var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtenimLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 27,
    viewBox: "0 0 174 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3147_2080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.5 26.3348V16.4592L147.165 26.3348H173.5Z",
    fill: "#2D5049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 0H147.165L173.5 9.87556V0Z",
    fill: "#2D5049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.525 13.1674L163.65 20.1681V6.16675L151.525 13.1674Z",
    fill: "#52DD91"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3147_2080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.96095 4.17676V11.1044H19.0468V15.2309H4.96095V22.1585H20.4668V26.3351H0V0.00477764H20.4668V4.17676H4.96095Z",
    fill: "#2D5049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8711 4.17653V11.1041H66.9569V15.2307H52.8711V22.1583H68.3769V26.3348H47.9101V0.00453941H68.3769V4.17653H52.8711Z",
    fill: "#2D5049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0536 0.0045397V26.3348H86.2737L76.8053 1.40277V26.3348H71.8398V0.0045397L81.6197 0L91.0927 24.9366V0.0045397H96.0536Z",
    fill: "#2D5049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.405 26.3348V0.00453941H105.366V26.3348H100.405Z",
    fill: "#2D5049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9454 0.00453741V4.36265H45.4277V0.00453741H22.9454Z",
    fill: "#2D5049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7447 6.18307L31.7309 26.3348H36.6461V4.36265L31.7447 6.18307Z",
    fill: "#2D5049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.419 0.00453941V26.3348H134.454V1.31197L128.806 26.3394H120.322L114.67 1.31197V26.3348H109.709V0.00453941H119.035L124.564 24.7096L130.093 0.00453941H139.419Z",
    fill: "#2D5049"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3147_2080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.3348,
    height: 26.3348,
    fill: "white",
    transform: "translate(147.165)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3147_2080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139.42,
    height: 26.3348,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtenimLogo);
export default __webpack_public_path__ + "static/media/etenim-logo.d8803d40393f30f02977828e9aacf82e.svg";
export { ForwardRef as ReactComponent };